import { css } from "emotion";
import { Component } from "preact";
import CMSComponent from "../../../components/CMSComponent";
import H3 from "../../../components/global/H3";
import TabMenu from "../../../components/TabMenu";
import { P } from "../../../components/text/TextComponents";
import { max, lastOfType } from "../../../utils/CssUtils";
import Plan from "./Plan";

const arrow = require("../../../assets/FeaturesAndPricing/ic_arrow.png");

const bannerWrapper = css({ backgroundColor: "#fafaf9" });

const bp = [1028, 800, 600];

const banner = css({
  maxWidth: 1040,
  margin: "0 auto",
  display: "block",
  textAlign: "center"
});

const bannerBlockWrapper = css({
  "&:after": {
    clear: "both",
    display: "block",
    content: '""'
  },
  [max(bp[0])]: {
    display: "none"
  }
});

const bannerBlockTabMenu = css({
  display: "none",
  "&:after": {
    clear: "both",
    display: "block",
    content: '""'
  },
  [max(bp[0])]: {
    display: "block",
    marginBottom: 12,
    marginTop: 40
  }
});

const headerWrapper = css({
  h3: {
    marginBottom: 46,
    textAlign: "center",
    [max(bp[0])]: {
      marginBottom: 26
    }
  }
});

const headerBody = css({
  display: "flex",
  maxWidth: 1200,
  justifyContent: "space-around",
  [max(bp[0])]: {
    flexDirection: "column"
  },
  div: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 48,
    maxWidth: 400,
    minHeight: 80,
    [max(bp[0])]: {
      marginBottom: 0
    },
    [lastOfType()]: {
      img: {
        transform: "rotate(180deg)"
      }
    }
  },
  img: {
    maxWidth: 18,
    maxHeight: 44,
    objectFit: "contain",
    marginRight: 16
  },
  p: {
    minHeight: 44,
    maxWidth: 300,
    textAlign: "left"
  }
});

class Plans extends Component {
  render() {
    const { defaultTab = 0, contentData, locale } = this.props;

    const free = {
      heading: "Free for free tickets",
      tabHeading: "Free events",
      color: "turquoise",
      priceBlock: {
        priceString: "$ Nothing. Nada. Zip.",
        perTicketNote: false,
        pricingDesc: null,
        buttonStyle: "hollow",
        buttonText: "Create event",
        isSignUpButton: true
      },
      featureList: {
        title: null,
        features: ["Every feature. No charge."]
      }
    };
    const standard = {
      heading: "Standard",
      tabHeading: "Standard",
      color: "purpleMid",
      priceBlock: {
        priceString: "4% + $0.99",
        perTicketNote: true,
        pricingDesc:
          "Unlike other platforms, this includes standard credit card fees and taxes. ",
        buttonStyle: "full",
        buttonText: "Create event",
        isSignUpButton: true
      },

      featureList: {
        title: "Full access to all features including:",
        features: [
          "Every feature.",
          "Support one of three incredible projects.",
          "Pass fees on to guests, or absorb the fees."
        ]
      }
    };
    const notForProfit = {
      heading: "Not-For-Profits and Schools",
      tabHeading: "Not-For-Profits",
      color: "blue",
      priceBlock: {
        priceString: "2.5% + $0.50",
        perTicketNote: true,
        pricingDesc:
          "Unlike other platforms, this includes standard credit card fees and taxes. ",
        buttonStyle: "hollow",
        buttonText: "Request access",
        buttonLink: `/${locale}/contact-us/organiser-support`
      },

      featureList: {
        title: "All Standard features plus:",
        features: [
          "Every feature.",
          "Special rates for non-profits, so you’ve got more money for your cause.",
          "Pass fees on to guests, or absorb the fees."
        ]
      }
    };

    if (contentData && contentData.data) {
      standard.priceBlock.priceString = contentData.data.standard.priceString;
      notForProfit.priceBlock.priceString =
        contentData.data.notForProfit.priceString;
    }

    const plans = [free, standard, notForProfit];

    const priceBlocksForTabMenu = plans.map(plan => {
      return {
        heading: plan.heading,
        tabHeading: plan.tabHeading,
        content: (
          <Plan
            heading={plan.heading}
            colour={plan.color}
            buttonBlock={plan.buttonBlock}
            priceBlock={plan.priceBlock}
            featureList={plan.featureList}
            locale={locale}
          />
        )
      };
    });

    return (
      <div className={bannerWrapper}>
        <div className={banner}>
          <div className={headerWrapper}>
            <H3>Do good, pay less.</H3>
            <div className={headerBody}>
              <div>
                <img src={arrow} alt="arrow icon up" />
                <P>100% of booking fees go toward closing the education gap.</P>
              </div>
              <div>
                <img src={arrow} alt="arrow icon down" />
                <P>
                  Most event organisers save 25% on fees when they switch to
                  Humanitix.
                </P>
              </div>
            </div>
          </div>
          <div className={bannerBlockTabMenu}>
            <TabMenu tabs={priceBlocksForTabMenu} defaultTab={defaultTab} />
          </div>

          <div className={bannerBlockWrapper}>
            {plans.map((block, i) => (
              <Plan
                //avoid nth-child selectors for preact ssr https://emotion.sh/docs/ssr
                firstPlan={i === 0}
                heading={block.heading}
                colour={block.color}
                buttonBlock={block.buttonBlock}
                priceBlock={block.priceBlock}
                featureList={block.featureList}
                locale={locale}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CMSComponent("pricingCards", Plans, 752);
